import styled, { css } from 'styled-components';
export const Card = styled.div `
    width: 100%;
    height: 100%;
    background-color: white;
    box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.108),
        0px 1.6px 3.6px rgba(0, 0, 0, 0.132);
    border-radius: 2px;
    transition: box-shadow 0.2s ease-in-out;

    &:hover {
        box-shadow: 0px 1.2px 3.6px rgba(0, 0, 0, 0.108),
            0px 6.4px 14.4px rgba(0, 0, 0, 0.132);
    }
`;
export const cardHeadingStyles = css `
    font-weight: 600;
    font-size: 14px;
    line-height: 40px;
    color: #171717;
    padding-left: 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    margin: 0;
`;
export const CardHeading = styled.h3 `
    ${cardHeadingStyles}
`;
export const CardContent = styled.div `
    height: calc(100% - 41px);
    position: relative;
    padding: 16px;
`;
//# sourceMappingURL=Card.js.map